  // src/services/admin/api.js
  import axiosInstance from '../axiosInstance';

  export const getDashboardData = async () => {
    try {
      debugger;
      const response = await axiosInstance.get('admin/dashboard');
      return response;
    } catch (error) {
      throw error;
    }
  };

  // Recent candidates list
  export const getRecentCandidates = async () => {
      try {
        debugger;
              const response = axiosInstance.get('admin/recent-candidates');

              return response;
      } catch (error) {
          throw error;
      }
  };

  export const getClientList = async () => {
    try {
      const response = await axiosInstance.get('admin/client/allClients');
      return response.data.data; // Returns the whole ApiResponse object
    } catch (error) {
      throw error;
    }
  };

  // Get admin profile by email
  export const getAdminProfileByEmail = async (email) => {
    try {
      const response = await axiosInstance.get(`admin/users/${email}`);
      return response.data.data; // Extract the `UserDto` from `ApiResponse`
    } catch (error) {
      console.error('Error fetching admin profile:', error);
      throw error;
    }
  };

  export const createEmployee = async (formData) => {
    try {
      const payload = {
        username: formData.username,
        companyname: formData.companyname,
        phonenumber: formData.contactNumber,
        email: formData.email,
        password: formData.contactNumber, // or a password field if separate
        role: "EMPLOYEE",
        gender: formData.gender.toUpperCase(),
        dateOfBirth: formData.dateOfBirth,
      };

      const response = await axiosInstance.post('admin/users/register', payload);
      return response.data;
    } catch (error) {
      console.error('❌ Error while creating employee:', error);
      if (error.response?.data?.message) {
        throw new Error(error.response.data.message); // "Email already in use."
      } else {
        throw new Error('Something went wrong while adding employee.');
      }
    }
  };


  export const getActiveEmployees = async () => {
    try {
      const response = await axiosInstance.get('admin/users/active-employees');
      return response.data.data; // Assuming your API response is wrapped in { success, message, data }
    } catch (error) {
      console.error('Error fetching active employees:', error);
      throw error;
    }
  };

  export const getInactiveEmployees = async () => {
    try {
      const response = await axiosInstance.get('admin/users/inactive-employees');
      return response.data.data; // assuming `ApiResponse<T>` => { status, statusCode, message, data }
    } catch (error) {
      console.error('Error fetching inactive employees:', error);
      throw error;
    }
  };


  export const updateEmployee = async (userId, updatedData) => {
    try {
      const updatedBy = localStorage.getItem('user_email');
      const response = await axiosInstance.put(`admin/users/${userId}`, updatedData, {
        headers: {
          'X-Updated-By': updatedBy,
        },
      });

      return response.data;
    } catch (error) {
      throw error;
    }
  };

  export const changeUserStatus = async (id, status) => {
    try {
      const response = await axiosInstance.put(`admin/users/${id}/changeStatus?status=${status}`);
      return response.data;
    } catch (error) {
      console.error('Error changing employee status:', error);
      throw error;
    }
  };

  export const deleteEmployee = (userId) => {
    return axiosInstance.delete(`/admin/users/${userId}`).then(res => res.data);
  };

  export const assignCandidateToEmployee = async (payload) => {
    const response = await axiosInstance.post('/admin/bgc-assignment/assign', payload);
    return response.data;
  };

  export const getAssignedCandidates = async (employeeId) => {
    try {
      const response = await axiosInstance.get(`admin/bgc-assignment/assigned/${employeeId}`);
      return response.data.data; // assuming ApiResponse<T> wraps data
    } catch (error) {
      console.error('Error fetching assigned candidates:', error);
      throw error;
    }
  };


  export const getClientCandidates = async (clientEmail, page = 0, size = 10) => {
    const res = await axiosInstance.get(`admin/client/client-candidates`, {
      params: {
        clientEmail,
        page,
        size
      }
    });
    return res.data;
  };

  export const getCandidateDetailsById = async (candidateId) => {
    try {
      const response = await axiosInstance.get(`admin/candidates/info/${candidateId}`);
      return response.data?.data?.data; // unwrap all layers
    } catch (error) {
      console.error(`Error fetching candidate info for ${candidateId}:`, error);
      throw error;
    }
  };

  export const fetchCandidateReport = async (candidateId) => {
  try {
    const response = await axiosInstance.post(`/admin/candidate-verification/candidate-report/${candidateId}`);
    return response.data?.data; // assuming ApiResponse<T>
  } catch (error) {
    console.error(`Error fetching candidate report for ${candidateId}:`, error);
    throw error;
  }
};

export const submitVerificationResult = async (payload) => {
  try {
    debugger;
    const response = await axiosInstance.post('/admin/candidate-verification/save', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get last 7 days client notifications
export const getRecentNotifications = async () => {
  try {
    const response = await axiosInstance.get('admin/notification/last7days');
    return response.data; // full ApiResponse
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw error;
  }
};

// Get candidate verification dashboard report
export const getCandidateDashboardReport = async () => {
  try {
    const response = await axiosInstance.get('/admin/candidate-verification/dashboardReport');
    return response.data; // full response (list of VerificationResult)
  } catch (error) {
    console.error('Error fetching dashboard report:', error);
    throw error;
  }
};
